<template>
  <Transition name="modal">
    <div v-if="showModalMain" class="" id="modalPromoMain">
      <div class="modal-container">
        <div class="modal-header">
          <button :class="isVideo ? 'close-black-video' : 'close-black'" @click="closeModalPromotionMain()">
            <img
              src="https://api.belladasemana.com.br/storage/2015/ico_x_black-t.png"
              alt="Close"
              class="close-modal"
            />
          </button>
        </div>
        <div class="modal-body">
          <a @click="goLink(link, 'main')">
            <video v-if="isVideo"
              muted autoplay loop playsinline
              style="cursor: pointer"
              :src="contentMain"
              alt="Promotional Video"
              title="Promotional Video"
            ></video>
            <img v-else
              style="cursor: pointer"
              :src="contentMain"
              alt="Promotional Banner"
              title="Promotional banner"
              :width="isMobile() ? 391 : 700"
              :height="isMobile() ? 378 : 677"
            />
          </a>
        </div>
      </div>
    </div>
  </Transition>

  <Transition
    name="footer"
    v-if="footerImageName"
    id="modalPromoFooter"
  >
    <div v-if="showModalFooter" class="">
      <div class="modal-container-footer">
        <div class="modal-header-footer">
          <button class="close-black" @click="closeModalPromotionFooter()">
            <img
              src="https://api.belladasemana.com.br/storage/2015/ico_x_black-t.png"
              alt="Close"
              class="close-modal"
            />
          </button>
        </div>
        <div class="modal-body-footer">
          <a @click="goLink(link, 'footer')">
            <img
              :src="imageFooter"
              style="cursor: pointer"
              alt="Promotional Banner"
              title="Promotional banner"
              :width="isMobile() ? 391 : 1230"
              :height="isMobile() ? 48 : 150"
            />
          </a>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { isMobile } from "@/shared/utils/mobile";
import { useCookies } from "vue3-cookies";
import { usePromotionAudience } from "@/composables/usePromotionAudience";

const route = useRoute();
const storePromotionPopup = promotionPopupStore();
const { canSeePromotion } = usePromotionAudience();

const { cookies } = useCookies();

const props = defineProps({
  optionsPromotionPopup: {
    type: Object,
    required: true,
  },
});

const showModalMain = ref(false);
const showModalFooter = ref(false);

// Árbitro único da tela. Antes, cada modal mantinha aqui a sua própria lista de
// concorrentes via document.getElementById — ver stores/modalArbiter.ts.
const arbitro = modalArbiterStore();

// Folga sobre o timer: a reserva precisa sobreviver ao tique de render entre o
// setTimeout disparar e o showModal() pedir a tela de fato.
const MARGEM_RESERVA_MS = 1000;
const contentMain = ref(
  "https://api.belladasemana.com.br/storage/promotions/" +
    props.optionsPromotionPopup.popup
);
const isVideo = computed(() => props.optionsPromotionPopup.popup?.substring(props.optionsPromotionPopup.popup.lastIndexOf('.') + 1).toLowerCase() === "mp4" ? true : false);

const footerImageName = computed(() =>
  isMobile()
    ? props.optionsPromotionPopup.side_banner
    : props.optionsPromotionPopup.footer_banner
);
const imageFooter = computed(
  () =>
    "https://api.belladasemana.com.br/storage/promotions/" + footerImageName.value
);
const link = ref("/pt-br/assine");

function goLink(link: string, origin: "main" | "footer") {
  // Clicar na promoção conta como fechamento: mesmo cookie/valor do X de cada popup.
  cookies.set("bellaPromoShow", origin === "footer" ? "2" : "0", 1000 * 60 * 60 * 24);
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "select_promotion",
    ecommerce: {
      promotion_name:
        props.optionsPromotionPopup.coupon ?? props.optionsPromotionPopup.name,
    },
  });
  window.location.href = link;
}

function linkPromotion() {
  // URL de destino customizada vinda do backend: já chega pronta (idioma e
  // cupom mesclados no servidor) — usar como está, sem re-prefixar o locale
  // nem anexar os sufixos de /assine.
  if (props.optionsPromotionPopup.customUrl) {
    link.value = props.optionsPromotionPopup.customUrl;
    return;
  }

  if (props.optionsPromotionPopup.coupon != "")
    link.value =
      "/" +
      route.params.language +
      "/assine?coupon=" +
      props.optionsPromotionPopup.coupon;

  if (props.optionsPromotionPopup.voucher != "")
    link.value =
      "/" +
      route.params.language +
      "/assine?voucher=" +
      props.optionsPromotionPopup.voucher;

  if (props.optionsPromotionPopup.couponDiscount != "")
    link.value =
      "/" +
      route.params.language +
      "/assine?coupon-discount=" +
      props.optionsPromotionPopup.couponDiscount;

  if (
    props.optionsPromotionPopup.coupon == "" &&
    props.optionsPromotionPopup.voucher == "" &&
    props.optionsPromotionPopup.couponDiscount == ""
  )
    link.value = "/" + (route.params.language ?? "pt-br") + "/assine";

  // Sem cupom a base não tem "?" — o separador precisa ser dinâmico para
  // não gerar "/assine&acionador=..." (404).
  if (props.optionsPromotionPopup.credits)
    link.value = appendQueryParam(link.value, "tab=credits");

  link.value = appendQueryParam(link.value, "acionador=ModalPromotionPopup");
}

function appendQueryParam(url: string, param: string) {
  return url + (url.includes("?") ? "&" : "?") + param;
}
function closeModalPromotionMain() {
  cookies.set("bellaPromoShow", "0", 1000 * 60 * 60 * 24);
  // Libera antes do showModal(): é ele que decide se o banner de rodapé entra
  // em seguida, e ele precisa encontrar a tela livre para conseguir a vez.
  arbitro.close("modalPromoMain");
  showModal();
  showModalMain.value = false;
}
function closeModalPromotionFooter() {
  cookies.set("bellaPromoShow", "2", 1000 * 60 * 60 * 24);
  arbitro.close("modalPromoFooter");
  showModalFooter.value = false;
}
/**
 * Guarda a vez na tela durante a espera do `banner_timer`.
 *
 * Sem isso a promoção perde sempre: ela se cala pelo tempo do timer (10s na
 * campanha no ar) enquanto a Saída do Assine decide em ~200ms e leva a tela.
 * Só segura quem de fato vai pedir — promoção fora do público-alvo, ou que já
 * foi vista e fechada, não bloqueia ninguém.
 *
 * @param  esperaMs  quanto falta do timer
 */
function segurarVezDaPromocao(esperaMs: number) {
  if (!canSeePromotion(props.optionsPromotionPopup)) {
    return;
  }

  const vaga = vagaQueSeraPedida({
    temPrincipal: Boolean(props.optionsPromotionPopup.popup),
    temRodape: Boolean(footerImageName.value),
    display: String(props.optionsPromotionPopup.display ?? ""),
    contagem: String(cookies.get("countAccessPromotion") ?? ""),
    estagio: cookies.get("bellaPromoShow"),
    rodapeDesligado: cookies.isKey("showFooterPromoBanner"),
  });

  if (vaga === null) {
    return;
  }

  arbitro.segurar(
    vaga === "principal" ? "modalPromoMain" : "modalPromoFooter",
    esperaMs + MARGEM_RESERVA_MS
  );
}

function tryModalPromotion() {
  var bellaTimerPromotion = storePromotionPopup.bellaTimerPromotionPopup;
  if (!bellaTimerPromotion.first_time_date) {
    var daysAccess = 1000 * 60 * 60 * 24 * 7; // 7 dias
    if (!cookies.isKey("countAccessPromotion")) {
      cookies.set("countAccessPromotion", "1", daysAccess);
    } else {
      if (parseInt(cookies.get("countAccessPromotion")) < 4) {
        cookies.set(
          "countAccessPromotion",
          String(parseInt(cookies.get("countAccessPromotion")) + 1),
          daysAccess
        );
      }
    }
    var params = {
      first_time_date: new Date().getTime(),
    };
    storePromotionPopup.setPromotionParams(params);
    bellaTimerPromotion = storePromotionPopup.bellaTimerPromotionPopup;
  }
  var timerParam = props.optionsPromotionPopup.banner_timer;
  var timerPromo = parseInt(timerParam) * 1000;
  if (timerPromo > 0) {
    if (!cookies.isKey("showFooterPromoBanner")) {
      var currentTimePromo = new Date().getTime();
      var diffPromo =
        currentTimePromo - Number(bellaTimerPromotion.first_time_date);
      var timeOutPromo =
        timerPromo - diffPromo < 0 ? 0 : timerPromo - diffPromo;
      segurarVezDaPromocao(timeOutPromo);
      setTimeout(() => {
        if (canSeePromotion(props.optionsPromotionPopup)) {
          showModal();
        }
      }, timeOutPromo);
    }
  } else {
    if (canSeePromotion(props.optionsPromotionPopup)) {
      showModal();
    }
  }
}
function showModal() {
  // Imagem null/vazia vinda da API = promoção sem popup principal; não exibir.
  if (props.optionsPromotionPopup.popup && cookies.get("bellaPromoShow") === "1") {
    if (props.optionsPromotionPopup.display != "") {
      var arrayDisplay = props.optionsPromotionPopup.display.toString();
      var arrayDisplay = arrayDisplay.split(",");
      if (
        arrayDisplay.includes(cookies.get("countAccessPromotion").toString())
      ) {
        if (arbitro.tryOpen("modalPromoMain")) {
          showModalMain.value = true;
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: "view_promotion",
            ecommerce: {
              promotion_name: props.optionsPromotionPopup.name,
            },
          });
        } else {
          showModalMain.value = false;
        }
      }
    }
  }
  // Sem popup principal (imagem null), o "0" nunca seria gravado — nesse caso o
  // footer pode aparecer direto no estado inicial "1".
  if (
    !cookies.isKey("showFooterPromoBanner") &&
    (cookies.get("bellaPromoShow") === "0" ||
      (cookies.get("bellaPromoShow") === "1" && !props.optionsPromotionPopup.popup))
  ) {
    if (footerImageName.value) {
      if (props.optionsPromotionPopup.display != "") {
        var arrayDisplay = props.optionsPromotionPopup.display.toString();
        var arrayDisplay = arrayDisplay.split(",");
        if (
          arrayDisplay.includes(cookies.get("countAccessPromotion").toString())
        ) {
          if (arbitro.tryOpen("modalPromoFooter")) {
            showModalFooter.value = true;
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: "view_promotion",
              ecommerce: {
                promotion_name: props.optionsPromotionPopup.coupon,
              },
            });
          } else {
            showModalFooter.value = false;
          }
        }
      }
    } else {
      cookies.set("showFooterPromoBanner", "0", 1000 * 60 * 60 * 7);
    }
  }

  if (showModalMain.value || showModalFooter.value) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "paywall",
      paywall: {
        acionador: "ModalPromotionPopup",
      },
    });
  }
}

onBeforeMount(() => {
  tryModalPromotion();
});

onMounted(() => {
  if (props.optionsPromotionPopup) linkPromotion();
});
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  transition: opacity 0.3s ease;
}

.modal-mask-footer {
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  transition: opacity 0.3s ease;
}

.modal-container {
  position: fixed;
  z-index: 9998;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 700px;
  margin: auto;
  padding: 0px 0px;
  background-color: transparent;
  border-radius: 0px;
  box-shadow: unset;
  transition: all 0.3s ease;
}

.modal-container-footer {
  z-index: 9999;
  padding: 0px 0px;
  background-color: #fff;
  border-radius: 0px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  opacity: 0.7;
  position: fixed;
  bottom: 0px;
  left: 50%;
  transform: translate(-50%);
  /* mantém o banner dentro da viewport (90%) até a largura de projeto (1230px),
     evitando o estouro horizontal que escondia o botão de fechar à direita */
  width: 90vw;
  max-width: 1230px;
}
.modal-header,
.modal-header-footer {
  display: block;
  text-align: center;
}

.modal-body,
.modal-body-footer {
  margin: 0;
  padding: 0px 0px;
}

.modal-default-button {
  float: right;
}

/*
* The following styles are auto-applied to elements with
* transition="modal" when their visibility is toggled
* by Vue.js.
*
* You can easily play with the modal transition by editing
* these styles.
*/

.modal-enter-from {
  opacity: 0;
}

.modal-leave-to {
  opacity: 0;
}

.modal-enter-from .modal-container,
.modal-leave-to .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.close-modal {
  width: 25px;
  height: 25px;
  margin: 3px;
}

.close-black, .close-black-video {
  position: absolute;
  right: 0px;
  top: 0px;
  z-index: 1;
}



:deep(.modal-body img) {
  width: 100%;
}

.modal-body video{
  max-width: 700px;
}

/* imagem do banner de rodapé acompanha a largura do container (90vw/max 1230px) */
:deep(.modal-body-footer img) {
  width: 100%;
  height: auto;
  display: block;
}

/* regras mobile 769vp */
@media screen and (max-width: 769px) {
  .modal-container,
  .modal-container-footer {
    width: 95%;
  }

  .modal-body video{
    max-width: 90%;
    left: 50%;
    transform: translate(-50%);    
  }

  :deep(.modal-body-footer img) {
    width: 100%;
    height: auto;
  }

  .close-modal {
    width: 20px;
    height: 20px;
    margin: 3px;
  }

  .close-black-video {
    right: 5%;
    top: 0px;
  }
}
</style>
